import { Background, Title } from './Home.styled';

const Home = () => {
  return (
    <Background>
      <Title>Welcome to Your Phonebook</Title>
    </Background>
  );
};
export default Home;
